import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <ButtonGroup variant="contained" aria-label="language switcher">
      <Button onClick={() => changeLanguage('en')} disabled={i18n.language === 'en'}>
        English
      </Button>
      <Button onClick={() => changeLanguage('sr')} disabled={i18n.language === 'sr'}>
        Српски
      </Button>
      <Button onClick={() => changeLanguage('srl')} disabled={i18n.language === 'srl'}>
        Srpski
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSwitcher;